export enum SocketStockEvEnum {
	A = 'A',
	Q = 'Q',
	T = 'T',
}
